<template>
  <div class="lp-add-pay-type-container unselect"
    @click.stop.prevent="clickAdd">
    <div class="add-box"
         :style="checkStyle"
         style="display:flex; justify-content: center; align-items: center">
      <i
         :style="iconStyle"
         class="material-icons">add</i>
    </div>
    <div :style="labelStyle">{{ label }}</div>
  </div>
</template>

<script>
  export default {
    props: {
      checkedVal: {
        type: Boolean
      },
      label: {
        type: String,
        required: false
      },
      item: {
        type: Object,
        required: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      checkBoxStyle: {
        type: Object,
        default: () => {
          return {
            width: '16px',
            height: '16px'
          }
        }
      },
      iconStyle: {
        type: Object,
        default: () => {
          return {
            color: '#AEAEAE',
            fontSize: '0.8rem',
            fontWeight: 'normal',
            left: '0px',
            top: '0px'
          }
        }
      },
      labelStyle: {
        type: Object,
        default: () => {
          return {
            fontSize: '0.9rem',
            lineHeight: '17px',
            color: '#AEAEAE'
          }
        }
      }
    },
    created() {
      this.isChecked = this.checkedVal;
      /*if(this.disabled) {
        this.isChecked = false;
      }*/
    },
    data() {
      return {
        isChecked: false
      }
    },
    computed: {
      checkStyle() {
        let style = {}
        style = this.checkBoxStyle;
        if(this.label) {
          style.marginRight = 8;
        }
        else style.marginRight = 0;

        return style
      }
    },
    methods: {
      clickCheck() {
        if(this.disabled) return;

        if ( this.isChecked === false ) {
          this.isChecked = true;
        }
        else if ( this.isChecked === true ) {
          this.isChecked = false;
        }
        this.$emit('update:checkedVal', this.isChecked);
        this.$emit('onCheck', this.isChecked);
        this.$emit('dataCheck', {id:this.label, value:this.isChecked});
      },
      clickAdd() {
        this.$store.commit('openModal', {type: 'modal-add-pay-type', value: this.item, background: false})
      }
    },
    watch: {
      disabled(n) {
        if(n) {
          this.isChecked = false;
          this.$emit('update:checkedVal', this.isChecked);
          this.$emit('onCheck', this.isChecked);
          this.$emit('dataCheck', {id:this.label, value:this.isChecked});
        }
      },
      checkedVal(n) {
        this.isChecked = n;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_variable'
  .lp-add-pay-type-container
    display flex
    flex-wrap wrap
    cursor pointer

  .add-box
    position relative
    border 1px solid #cccccc
    border-radius 2px
    margin-right 8px
    text-align center
    background-color #fff

  /*.lp-check-bool-label*/
    // display flex

</style>
